import * as msal from '@azure/msal-browser'
import FUNCTION_API_BASE from '../functions';

const msalConfig = {
  auth: {
    clientId: 'db888e18-a667-49fb-a490-1851e6b7e953',
    authority:
      // 'https://SiliconCraftTechnologyB2C.b2clogin.com/tfp/SiliconCraftTechnologyB2C.onmicrosoft.com/B2C_1_sicwebapp_signupsignin',
      // 'https://SiliconCraftTechnologyB2C.b2clogin.com/tfp/SiliconCraftTechnologyB2C.onmicrosoft.com/B2C_1_customer_signupsignin',
      'https://SiliconCraftTechnologyB2C.b2clogin.com/tfp/SiliconCraftTechnologyB2C.onmicrosoft.com/B2C_1A_CustomerPortal_signup_signin',
    knownAuthorities: ['SiliconCraftTechnologyB2C.b2clogin.com'],
    // redirectUri: 'http://localhost:8080/'
    redirectUri: "https://webapp.sic.co.th/customer-portal/"
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

const msalInstance = new msal.PublicClientApplication(msalConfig);

async function initialize() {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.log(error);
  }
}

export default {
  async login(context) {
    try {
      await msalInstance.clearCache();
      localStorage.clear()

      await initialize();

      const loginRequest = {
        scopes: ["openid", "https://SiliconCraftTechnologyB2C.onmicrosoft.com/7d50f809-7ed1-4bd6-a4b0-451b9595dcf1/Customer.Read"],
        prompt: 'select_account',
      };
      var authUser = await msalInstance.loginPopup(loginRequest)

      const user = {
        token: authUser.accessToken,
      }

      context.commit('setAccessToken', user)
    } catch(err) {
      // empty catch
    }
  },
  async logout(context, payload) {
    const logoutRequest = {
      account: msalInstance.getAccountByHomeId(payload.homeAccountId),
      // mainWindowRedirectUri: "http://localhost:8080",
      mainWindowRedirectUri: "https://webapp.sic.co.th/customer-portal"
    };
    await msalInstance.logoutPopup(logoutRequest);

    context.commit('setAccessToken', {
      token: null,
    })
    context.commit('setUser', {
      account: null,
    })
  },
  async resetToken(context) {
    await initialize();
    const tokenRequest = {
      scopes: ["openid", "https://SiliconCraftTechnologyB2C.onmicrosoft.com/7d50f809-7ed1-4bd6-a4b0-451b9595dcf1/Customer.Read"],
    };

    const accessTokenRequest = {
      tokenRequest,
      account: msalInstance.getAllAccounts()[0],
      scopes: ["https://SiliconCraftTechnologyB2C.onmicrosoft.com/7d50f809-7ed1-4bd6-a4b0-451b9595dcf1/Customer.Read"]
    }

    let tokenResp
    try {
      tokenResp = await msalInstance.acquireTokenSilent(accessTokenRequest);

      context.commit('setAccessToken', {
        token: tokenResp.accessToken
      })
    } catch (err) {
      context.commit('setAccessToken', {
        token: null,
      })
    }
  },
  async getUser(context) {
    try {
      const response = await fetch(`${FUNCTION_API_BASE}GetUser`, {
        method: 'GET',
        headers: { "Authorization": `Bearer ${context.getters.accessToken}` },
      })

      const responseData = await response.json();

      context.commit('setUser', {
        account: responseData.User
      })
    } catch {
      context.commit('setAccessToken', {
        token: null,
      })
      context.commit('setUser', {
        account: null,
      })
    }
  },
}